import React from 'react';
import ModalLayout from '@components/Modal/ModalLayout';
import ConfirmModal from '@components/Modal/ConfirmModal';

export const ConfirmUpdateModal = ({
  isOpen,
  onClose,
  handleSubmit,
  handleCancel,
  prompt,
  isLoading
}) => (
  <ModalLayout isOpen={isOpen} onClose={onClose} textAlign="center" size="md">
    <ConfirmModal
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      prompt={prompt}
      isLoading={isLoading}
    />
  </ModalLayout>
);
